import '../../sass/about/about.sass'

//其他Methods
import { methods } from '../includes/_methods'

methods.getBannerSrc('.commonBn .bn_bg',0);
_common.nav_scroll('.commonBn')
_common.sortArrow('.abtLink','.link_wrap','.link_left','.link_right')

const about_7 = {
  tableAlgin (){
    // $(obj).find('.td p').css('width','')
    if($(window).width() < 993) return
    let maxWidth = 0
    $('.abtLoc .loc_li').each(function(){ // x3
      let width = $(this).find('.name_wrap').outerWidth();
      if(width >= maxWidth){
        maxWidth = width
      }else{}
    })
    $('.abtLoc .loc_li').each(function(){
      $(this).find('.name_wrap').css('width',maxWidth+1);
    })
  }
}
about_7.tableAlgin();



import * as am4core from '@amcharts/amcharts4/core';
import * as am4maps from '@amcharts/amcharts4/maps';
import am4geodata_worldLow from '@amcharts/amcharts4-geodata/worldLow';

const map = {
  getLocationData() {
    const $li = $('.abtLoc .loc_li'),
          imgURL = $('.abtLoc .loc_wrap').attr('data-icon'),
          hoverImgURL = $('.abtLoc .loc_wrap').attr('data-hover-icon');
    let locationData = [];
    [...$li].forEach((item, index) => {
      locationData.push({
        title: item.dataset.title,
        latitude: Number(item.dataset.latitude),
        longitude: Number(item.dataset.longitude),
        target: `.abtLoc .loc_li:nth-child(${index+1})`,
        imageURL: imgURL,
        hoverImageURL: hoverImgURL,
      })
    });
    return locationData;
  },
  createMap() {
    // Create map instance
    let chart = am4core.create("chartdiv", am4maps.MapChart);
  
    // Set map definition
    chart.geodata = am4geodata_worldLow;
  
    // Set projection
    chart.projection = new am4maps.projections.Miller();
  
    // Create map polygon series
    let polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
    // Exclude Antartica
    polygonSeries.exclude = ["AQ"];
    // Make map load polygon (like country names) data from GeoJSON
    polygonSeries.useGeodata = true;
    // Configure series
    let polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.fill = am4core.color("#949494");
    // polygonTemplate.tooltipText = "{name}";
    polygonTemplate.polygon.fillOpacity = 1;
    polygonTemplate.strokeOpacity = .4;
    polygonTemplate.strokeWidth = .4;
  
    // Create hover state and set alternative fill color
    let hs = polygonTemplate.states.create("hover");
    hs.properties.fill = am4core.color("#666");
  
    // Add image series
    let imageSeries = chart.series.push(new am4maps.MapImageSeries());
    imageSeries.tooltip.background.strokeWidth = 0;
    // imageSeries.tooltip.background.cornerRadius = 10;
    imageSeries.tooltip.fontSize = 15;
    imageSeries.tooltip.fontWeight = 700;
    let imageTemplate = imageSeries.mapImages.template;
    imageTemplate.propertyFields.longitude = "longitude";
    imageTemplate.propertyFields.latitude = "latitude";
    imageTemplate.tooltipText = "{title}";
    imageTemplate.tooltipY = -18;
    imageTemplate.nonScaling = true;
  
    let image = imageTemplate.createChild(am4core.Image);
    image.propertyFields.href = "imageURL";
    image.width = 18;
    image.height = 25;
    image.horizontalCenter = "middle";
    image.verticalCenter = "bottom";
    image.events.on('hit', function(ev) {
      console.log("clicked on ", ev.target);
      const anchorTarget = $(ev.target.dataItem.dataContext.target),
            targetTop = anchorTarget.offset().top - 150;
      $('html, body').animate({scrollTop: targetTop}, {duration: 500});
    }, this)
    
    // hover
    let hoverChange = image.states.create('hover');
    hoverChange.propertyFields.href = 'hoverImageURL';

    imageSeries.data = map.getLocationData();
  }
}

$(function() {
  map.createMap();
})



